import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/home';

const anchors: Record<string, string> = {
  'cat-psych': '#psych',
  'cat-facts': '#facts',
  'cat-jokes': '#jokes',
  'cat-memes': '#memes',
  'cat-guide': '#guide',
  'cat-mood': '#about',
};

export default function Categories() {
  return (
    <section id="categories" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="主题分类"
          title="六块瓜田，总有一块合你口味"
          desc="从心理机制到表情包，从围观指南到情绪观察，我们按你当下的心情来分门别类。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat, index) => (
            <a
              key={cat.id}
              href={anchors[cat.id] ?? '#hot'}
              className="group rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 hover:border-primary-300 hover:bg-primary-50/60 transition-colors"
            >
              <div className="flex items-start justify-between">
                <span
                  className={`w-14 h-14 rounded-lg flex items-center justify-center text-2xl ${
                    index % 2 === 0 ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                  }`}
                >
                  <i className={cat.icon} />
                </span>
                <span className="text-xs text-foreground-400">{cat.count} 篇内容</span>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-950 mt-4 flex items-center gap-2">
                {cat.name}
                <i className="ri-arrow-right-up-line text-base text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity" />
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}